/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef, useState } from "react";

// Controls / utils
import Btn from "./main.content.btn";
import BtnExport from "./main.content.btn.export";
import BtnCalendar from "./main.content.btn.calendar";
import SelectLimit from "./main.content.select.limit";
import ModalView from "./modal.view";
import ModalEdit from "./modal.edit";
import ModalExport from "./modal.export";
import API from "../../utils/API";

// Tabs content
import SummaryTab from "./summary.tab";
import RequestsTab from "./requests.tab";

/** base path ของเพจนี้ (แก้ได้ถ้า mount ที่ path อื่น) */
const BASE_PATH = "/hrms/team";

/** อ่าน tab จาก pathname: /hrms/team/{tab} */
function readTabFromPath() {
  try {
    const segs = window.location.pathname.replace(/\/+$/, "").split("/");
    const last = segs[segs.length - 1];
    if (last === "summary" || last === "request") return last;
    return "request";
  } catch {
    return "request";
  }
}

/** สร้าง path ใหม่ให้ตรงกับแท็บ */
function makePathForTab(tab) {
  const search = window.location.search || "";
  return `${BASE_PATH}/${tab}${search}`;
}

/** push state (ไม่รีเฟรช) */
function pushTabToPath(tab) {
  const newUrl = makePathForTab(tab);
  window.history.pushState({}, "", newUrl);
}

export default function MainContent({
  userData,
  filterData, // decrypt.data จาก index.js
  filters, // single source of truth จาก index.js
  setFilters,
  defaultFilters }) {
  // --- active tab sync กับ PATH ---
  const [activeTab, setActiveTab] = useState(readTabFromPath());

  // --- data fetch states ---
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null); // เก็บข้อมูลที่ดึงมาเมื่อกด Search

  useEffect(() => {
    const onPop = () => setActiveTab(readTabFromPath()); // รองรับ back/forward
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const switchTab = (tab) => {
    if (tab === activeTab) return;
    setActiveTab(tab);
    pushTabToPath(tab); // /hrms/team/{tab}
  };

  // ยิง API — รับ overrideFilters เพื่อยิงทันทีจากปุ่ม Search ด้านบน (Btn)
  const fetchData = async (overrideFilters) => {
    try {
      console.log("[fetchData] start");
      setLoading(true);

      const endpoint =
        activeTab === "summary" ? "team/summary" : "team/request";
      const f = overrideFilters ?? filters;
      const payload = {
        country: f.country ?? [],
        department: f.department ?? [],
        division: f.division ?? [],
        start_date: f.start_date,
        end_date: f.end_date,
        status: f.status,
        leavetype: f.leavetype ?? [],
        duration: f.duration ?? [],
        location: f.location ?? [],
        email: typeof f.email === "string" ? [f.email.trim()] : [],
        name: typeof f.name === "string" ? [f.name.trim()] : [],
        limit: f.limit ?? 10,
        page: f.page ?? 1 };
      // console.log("[fetchData] payload =", payload);

      const paramsBody = { userID: userData.idu, filters: payload };
      const encrypted = (paramsBody);

      const res = await API.post(endpoint, { params: encrypted });
      const data = (res?.data);
      if (data?.status !== "success") {
        throw new Error(data?.err_msg || "Unknown error");
      }

      // ส่ง inner data ให้แท็บใช้
      setResult(data);
    } catch (e) {
      console.error("[fetchData] ERROR:", e);
      setError(e?.message || String(e));
    } finally {
      setLoading(false);
      console.log("[fetchData] done. loading=false");
    }
  };

  // --- Auto-fetch ครั้งแรกเมื่อทุกอย่างพร้อม ---
  const isFiltersReady =
    !!filters?.start_date?.[0] &&
    !!filters?.end_date?.[0] &&
    Array.isArray(filters?.country) &&
    filters.country.length > 0;

  const isFilterDataReady = filterData && Object.keys(filterData).length > 0;

  useEffect(() => {
    if (!isFiltersReady || !isFilterDataReady) return;

    setError("");
    setResult(null);
    fetchData(); // ใช้ activeTab/filters ปัจจุบัน
  }, [activeTab, filters.key_form]);

  return (
    <div id="main-content">
      {/* Controls: Search / Clear จะอัปเดต filters กลาง + ยิง API ผ่าน onSearch */}
      <Btn
        defaultFilters={defaultFilters}
        setFilters={setFilters}
        setReqData={setResult}
        filters={filters}
        onSearch={(newFilters) => fetchData(newFilters)} // ✅ ปุ่ม Search สั่งยิง API ทันที
      />

      {/* Header: Tabs + actions */}
      <div
        className="tabs-actions-row"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
          flexWrap: "wrap",
          marginBottom: 30 }}
      >
        <div className="pill-tabs" style={{ display: "flex", gap: 12 }}>
          <button
            type="button"
            className={`pill-tab ${activeTab === "summary" ? "active" : ""}`}
            onClick={() => switchTab("summary")}
          >
            TEAM LEAVE SUMMARY
          </button>
          <button
            type="button"
            className={`pill-tab ${activeTab === "request" ? "active" : ""}`}
            onClick={() => switchTab("request")}
          >
            TEAM LEAVE REQUESTS
          </button>
        </div>

        <div
          className="actions-wrap"
          style={{ display: "flex", alignItems: "center", gap: 12 }}
        >
          <SelectLimit
            limit={filters.limit}
            setFilters={setFilters}
            setReqData={setResult}
          />
          <BtnCalendar />
          <BtnExport />
        </div>
      </div>

      {/* Content */}
      <div className="tab-content">
        {/* states แสดงผล */}
        {error && (
          <div style={{ marginBottom: 12, color: "#c62828" }}>
            Error: {error}
          </div>
        )}
        {!error && !loading && !result && (
          <div style={{ marginBottom: 12, opacity: 0.7 }}>
            กด <b>Search</b> เพื่อดึงข้อมูล
          </div>
        )}

        {activeTab === "summary" ? (
          <SummaryTab
            userData={userData}
            filters={filters}
            setFilters={setFilters}
            data={result}
            loading={loading}
          />
        ) : (
          <RequestsTab
            userData={userData}
            filters={filters}
            setFilters={setFilters}
            data={result}
            loading={loading}
          />
        )}
      </div>

      {/* Modals */}
      <ModalView />
      <ModalEdit setFilters={setFilters} setReqData={() => {}} addon={{}} />
      <ModalExport activeTab={activeTab} filters={filters} />
    </div>
  );
}


